<template>
  <div class="w-100">
      <Loader class="w-100" :loading="loading">
          <div class=" p-list-representation-wrapper align-items-start">
              <div  class="w-100p-list-representation-content row mr-auto ml-auto align-items-start">
                <div class="w-100" >
                  <appHeader></appHeader>
                </div>

                <div class=" row p-list-representation-data w-100" :key="updateTeam">
                  <contentList
                  @submitData="submitData"



                  :selected-player="selectedPlayer"
                  :selected-cup="selectedCup"

                  :players-data="playersData"
                  :cups-data="cupsData"
                  :page="page"
                  :form-data="formData"
                  ></contentList>
                </div>

              </div>

          </div>

      </Loader>
  </div>
</template>

<script>
import contentList from '../components/editTeam/contentList';
import appHeader from '../components/includes/AppHeader';
import addCama from '../modules/addCama.js'
import settings from '../modules/settings';



export default {
  name: "editTeam",
  components: {
    contentList,
    appHeader,
  },

  props: {

  },

  data() {
    return {
      loading                                 : false,
      updateCitySelected                      : 0,
      page                                    : 0,
      checkEmptyCity                     : 'default',
      formData   : {
        image           : '',
        name            : '',
        slogan          : '',
        birth_date      : '',
        mobile          : '',
        national_code   : '',
        full_name       : '',
        creator_image   : '',

        cup_id          : '',
        player_id       : '',

        id              : '',
        include_owner   : 1,
        include_players : 1,
        include_cup     : 1,
        per_page        : 10,
        page            :  1,
      },
      tableData                               : [],
      page                                    : 1,
      statusRunPaganation                     : true,
      resetPagePaganation                     : 0,
      cupsData                                : [

      ],
      playersData                             : [

      ],
      selectedPlayer : {

      },
      selectedCup : {

      },
      statusGetCupAndGetPlayer : false,
      updateTeam               : 0,
      singleDataTeam           : {},


    }
  },

  watch: {
    singleDataTeam(data){
      this.formData = data;
      this.getAndSetDefaultData();
      this.updateTeam++;
    }

  },

  created() {
  },


  mounted() {
    const getParams = this.$route.params.id;

    if (typeof(getParams) != 'undefined') {
      this.formData.id      = getParams;
      const  singleDataTeam = JSON.parse(localStorage.getItem('singleDataTeam'));
      this.singleDataTeam   = singleDataTeam;
    }


  },


  methods: {
    submitData(data){
      delete this.formData.image;
      this.loading      = true;

      this.$store
      .dispatch('teams/newAndEditDataTeam', {
        data : {
          ...this.formData,
        }
      })
      .then((res)=>{
        localStorage.setItem('singleDataTeam', JSON.stringify(data));
        this.loading      = false;
        this.$router.push({name:'Team' } )
      })
    },

    getAndSetDefaultData(){
      const cupSelected           = this.formData.cup;
      const playerSelected        = this.formData.players;
      let findPlayerCurrent       = {};

      playerSelected.map((t)=>{
        if (t.id == this.formData.player_id) {
          const concatFullName    = `${t.name} ${t.family}`
          t.fullNamePlayer        = concatFullName;
          findPlayerCurrent       = t;
        }
      })

      console.log(findPlayerCurrent);
      this.selectedCup     = cupSelected;
      this.selectedPlayer  = {id:findPlayerCurrent.id,concatPlayerNameAndFamily:findPlayerCurrent.fullNamePlayer};
    },

    concatPlayerDataNameAndFamily(allPlayers){
      allPlayers.map((t)=>{
        const concatFullName            = `${t.name} ${t.family}`
        t.concatPlayerNameAndFamily     = concatFullName;
      })
    },





  }


}
</script>
